import { default as index1kAcWuUNdRMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93IipEN5KhGWMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/[...slug].vue?macro=true";
import { default as indexjadrxMhwZZMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/account/index.vue?macro=true";
import { default as _91id_93VruJ4Y7kKTMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/account/orders/[id].vue?macro=true";
import { default as ordersWnd4T0i6XGMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/account/orders.vue?macro=true";
import { default as index1BRtdwYX6PMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/account/user/index.vue?macro=true";
import { default as basketNNjt17wlKrMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/basket.vue?macro=true";
import { default as _91_46_46_46slug_93a2S8zjO3NJMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/c/[...slug].vue?macro=true";
import { default as checkout_external_basket0ZkW2bFpLkMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/checkout_external_basket.vue?macro=true";
import { default as checkout0t3g448gT0Meta } from "/home/runner/work/mad-storefront/mad-storefront/pages/checkout.vue?macro=true";
import { default as _91slug_930FDHUUHI60Meta } from "/home/runner/work/mad-storefront/mad-storefront/pages/magazine/[slug].vue?macro=true";
import { default as indexI5jST10Ox7Meta } from "/home/runner/work/mad-storefront/mad-storefront/pages/magazine/index.vue?macro=true";
import { default as indexYRRviafY4NMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/outfits/[slug]/index.vue?macro=true";
import { default as indexWsv6dmpwmFMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/outfits/index.vue?macro=true";
import { default as _91id_93xNZ5onoXuDMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/p/[slug]/[id].vue?macro=true";
import { default as resetnp3VX88zp2Meta } from "/home/runner/work/mad-storefront/mad-storefront/pages/password/reset.vue?macro=true";
import { default as searchNZaPMep8ZGMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/search.vue?macro=true";
import { default as direct_45order4GeNbkm3miMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/service/direct-order.vue?macro=true";
import { default as signinXR83XyCrKPMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/signin.vue?macro=true";
import { default as successKgd34y9kwZMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/success.vue?macro=true";
import { default as wishlist1HFchInhXDMeta } from "/home/runner/work/mad-storefront/mad-storefront/pages/wishlist.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: index1kAcWuUNdRMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "slug___at",
    path: "/at/:slug(.*)*",
    meta: _91_46_46_46slug_93IipEN5KhGWMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___be",
    path: "/be/:slug(.*)*",
    meta: _91_46_46_46slug_93IipEN5KhGWMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___fr-be",
    path: "/fr-be/:slug(.*)*",
    meta: _91_46_46_46slug_93IipEN5KhGWMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___ch",
    path: "/ch/:slug(.*)*",
    meta: _91_46_46_46slug_93IipEN5KhGWMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___fr-ch",
    path: "/fr-ch/:slug(.*)*",
    meta: _91_46_46_46slug_93IipEN5KhGWMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    meta: _91_46_46_46slug_93IipEN5KhGWMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    meta: _91_46_46_46slug_93IipEN5KhGWMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    meta: _91_46_46_46slug_93IipEN5KhGWMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___uk",
    path: "/uk/:slug(.*)*",
    meta: _91_46_46_46slug_93IipEN5KhGWMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "account___at",
    path: "/at/account",
    meta: indexjadrxMhwZZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___be",
    path: "/be/account",
    meta: indexjadrxMhwZZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___fr-be",
    path: "/fr-be/account",
    meta: indexjadrxMhwZZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___ch",
    path: "/ch/account",
    meta: indexjadrxMhwZZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___fr-ch",
    path: "/fr-ch/account",
    meta: indexjadrxMhwZZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___de",
    path: "/de/account",
    meta: indexjadrxMhwZZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___fr",
    path: "/fr/account",
    meta: indexjadrxMhwZZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___nl",
    path: "/nl/account",
    meta: indexjadrxMhwZZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account___uk",
    path: "/uk/account",
    meta: indexjadrxMhwZZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/index.vue").then(m => m.default || m)
  },
  {
    name: "account-orders___at",
    path: "/at/account/orders",
    meta: ordersWnd4T0i6XGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___at",
    path: ":id()",
    meta: _91id_93VruJ4Y7kKTMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-orders___be",
    path: "/be/account/orders",
    meta: ordersWnd4T0i6XGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___be",
    path: ":id()",
    meta: _91id_93VruJ4Y7kKTMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-orders___fr-be",
    path: "/fr-be/account/orders",
    meta: ordersWnd4T0i6XGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___fr-be",
    path: ":id()",
    meta: _91id_93VruJ4Y7kKTMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-orders___ch",
    path: "/ch/account/orders",
    meta: ordersWnd4T0i6XGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___ch",
    path: ":id()",
    meta: _91id_93VruJ4Y7kKTMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-orders___fr-ch",
    path: "/fr-ch/account/orders",
    meta: ordersWnd4T0i6XGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___fr-ch",
    path: ":id()",
    meta: _91id_93VruJ4Y7kKTMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-orders___de",
    path: "/de/account/orders",
    meta: ordersWnd4T0i6XGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___de",
    path: ":id()",
    meta: _91id_93VruJ4Y7kKTMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-orders___fr",
    path: "/fr/account/orders",
    meta: ordersWnd4T0i6XGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___fr",
    path: ":id()",
    meta: _91id_93VruJ4Y7kKTMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-orders___nl",
    path: "/nl/account/orders",
    meta: ordersWnd4T0i6XGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___nl",
    path: ":id()",
    meta: _91id_93VruJ4Y7kKTMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-orders___uk",
    path: "/uk/account/orders",
    meta: ordersWnd4T0i6XGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders.vue").then(m => m.default || m),
    children: [
  {
    name: "account-orders-id___uk",
    path: ":id()",
    meta: _91id_93VruJ4Y7kKTMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/orders/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "account-user___at",
    path: "/at/account/user",
    meta: index1BRtdwYX6PMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "account-user___be",
    path: "/be/account/user",
    meta: index1BRtdwYX6PMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "account-user___fr-be",
    path: "/fr-be/account/user",
    meta: index1BRtdwYX6PMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "account-user___ch",
    path: "/ch/account/user",
    meta: index1BRtdwYX6PMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "account-user___fr-ch",
    path: "/fr-ch/account/user",
    meta: index1BRtdwYX6PMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "account-user___de",
    path: "/de/account/user",
    meta: index1BRtdwYX6PMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "account-user___fr",
    path: "/fr/account/user",
    meta: index1BRtdwYX6PMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "account-user___nl",
    path: "/nl/account/user",
    meta: index1BRtdwYX6PMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "account-user___uk",
    path: "/uk/account/user",
    meta: index1BRtdwYX6PMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/account/user/index.vue").then(m => m.default || m)
  },
  {
    name: "basket___at",
    path: "/at/basket",
    meta: basketNNjt17wlKrMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___be",
    path: "/be/basket",
    meta: basketNNjt17wlKrMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___fr-be",
    path: "/fr-be/basket",
    meta: basketNNjt17wlKrMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___ch",
    path: "/ch/basket",
    meta: basketNNjt17wlKrMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___fr-ch",
    path: "/fr-ch/basket",
    meta: basketNNjt17wlKrMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___de",
    path: "/de/basket",
    meta: basketNNjt17wlKrMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___fr",
    path: "/fr/basket",
    meta: basketNNjt17wlKrMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___nl",
    path: "/nl/basket",
    meta: basketNNjt17wlKrMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "basket___uk",
    path: "/uk/basket",
    meta: basketNNjt17wlKrMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/basket.vue").then(m => m.default || m)
  },
  {
    name: "c-slug___at",
    path: "/at/c/:slug(.*)*",
    meta: _91_46_46_46slug_93a2S8zjO3NJMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "c-slug___be",
    path: "/be/c/:slug(.*)*",
    meta: _91_46_46_46slug_93a2S8zjO3NJMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "c-slug___fr-be",
    path: "/fr-be/c/:slug(.*)*",
    meta: _91_46_46_46slug_93a2S8zjO3NJMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "c-slug___ch",
    path: "/ch/c/:slug(.*)*",
    meta: _91_46_46_46slug_93a2S8zjO3NJMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "c-slug___fr-ch",
    path: "/fr-ch/c/:slug(.*)*",
    meta: _91_46_46_46slug_93a2S8zjO3NJMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "c-slug___de",
    path: "/de/c/:slug(.*)*",
    meta: _91_46_46_46slug_93a2S8zjO3NJMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "c-slug___fr",
    path: "/fr/c/:slug(.*)*",
    meta: _91_46_46_46slug_93a2S8zjO3NJMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "c-slug___nl",
    path: "/nl/c/:slug(.*)*",
    meta: _91_46_46_46slug_93a2S8zjO3NJMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "c-slug___uk",
    path: "/uk/c/:slug(.*)*",
    meta: _91_46_46_46slug_93a2S8zjO3NJMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/c/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___at",
    path: "/at/checkout_external_basket",
    meta: checkout_external_basket0ZkW2bFpLkMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___be",
    path: "/be/checkout_external_basket",
    meta: checkout_external_basket0ZkW2bFpLkMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___fr-be",
    path: "/fr-be/checkout_external_basket",
    meta: checkout_external_basket0ZkW2bFpLkMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___ch",
    path: "/ch/checkout_external_basket",
    meta: checkout_external_basket0ZkW2bFpLkMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___fr-ch",
    path: "/fr-ch/checkout_external_basket",
    meta: checkout_external_basket0ZkW2bFpLkMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___de",
    path: "/de/checkout_external_basket",
    meta: checkout_external_basket0ZkW2bFpLkMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___fr",
    path: "/fr/checkout_external_basket",
    meta: checkout_external_basket0ZkW2bFpLkMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___nl",
    path: "/nl/checkout_external_basket",
    meta: checkout_external_basket0ZkW2bFpLkMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout_external_basket___uk",
    path: "/uk/checkout_external_basket",
    meta: checkout_external_basket0ZkW2bFpLkMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout_external_basket.vue").then(m => m.default || m)
  },
  {
    name: "checkout___at",
    path: "/at/checkout",
    meta: checkout0t3g448gT0Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___be",
    path: "/be/checkout",
    meta: checkout0t3g448gT0Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___fr-be",
    path: "/fr-be/checkout",
    meta: checkout0t3g448gT0Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___ch",
    path: "/ch/checkout",
    meta: checkout0t3g448gT0Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___fr-ch",
    path: "/fr-ch/checkout",
    meta: checkout0t3g448gT0Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___de",
    path: "/de/checkout",
    meta: checkout0t3g448gT0Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___fr",
    path: "/fr/checkout",
    meta: checkout0t3g448gT0Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___nl",
    path: "/nl/checkout",
    meta: checkout0t3g448gT0Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "checkout___uk",
    path: "/uk/checkout",
    meta: checkout0t3g448gT0Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/checkout.vue").then(m => m.default || m)
  },
  {
    name: "index___at",
    path: "/at",
    meta: index1kAcWuUNdRMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___be",
    path: "/be",
    meta: index1kAcWuUNdRMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___fr-be",
    path: "/fr-be",
    meta: index1kAcWuUNdRMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ch",
    path: "/ch",
    meta: index1kAcWuUNdRMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___fr-ch",
    path: "/fr-ch",
    meta: index1kAcWuUNdRMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___de",
    path: "/de",
    meta: index1kAcWuUNdRMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: index1kAcWuUNdRMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: index1kAcWuUNdRMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___uk",
    path: "/uk",
    meta: index1kAcWuUNdRMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___at",
    path: "/at/magazin/:slug()",
    meta: _91slug_930FDHUUHI60Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___be",
    path: "/be/magazine/:slug()",
    meta: _91slug_930FDHUUHI60Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___fr-be",
    path: "/fr-be/magazine/:slug()",
    meta: _91slug_930FDHUUHI60Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___ch",
    path: "/ch/magazin/:slug()",
    meta: _91slug_930FDHUUHI60Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___fr-ch",
    path: "/fr-ch/magazine/:slug()",
    meta: _91slug_930FDHUUHI60Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___de",
    path: "/de/magazin/:slug()",
    meta: _91slug_930FDHUUHI60Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___fr",
    path: "/fr/magazine/:slug()",
    meta: _91slug_930FDHUUHI60Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___nl",
    path: "/nl/magazine/:slug()",
    meta: _91slug_930FDHUUHI60Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine-slug___uk",
    path: "/uk/magazine/:slug()",
    meta: _91slug_930FDHUUHI60Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/[slug].vue").then(m => m.default || m)
  },
  {
    name: "magazine___at",
    path: "/at/magazin",
    meta: indexI5jST10Ox7Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine___be",
    path: "/be/magazine",
    meta: indexI5jST10Ox7Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine___fr-be",
    path: "/fr-be/magazine",
    meta: indexI5jST10Ox7Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine___ch",
    path: "/ch/magazin",
    meta: indexI5jST10Ox7Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine___fr-ch",
    path: "/fr-ch/magazine",
    meta: indexI5jST10Ox7Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine___de",
    path: "/de/magazin",
    meta: indexI5jST10Ox7Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine___fr",
    path: "/fr/magazine",
    meta: indexI5jST10Ox7Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine___nl",
    path: "/nl/magazine",
    meta: indexI5jST10Ox7Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "magazine___uk",
    path: "/uk/magazine",
    meta: indexI5jST10Ox7Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/magazine/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___at",
    path: "/at/outfits/:slug()",
    meta: indexYRRviafY4NMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___be",
    path: "/be/outfits/:slug()",
    meta: indexYRRviafY4NMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___fr-be",
    path: "/fr-be/ensembles/:slug()",
    meta: indexYRRviafY4NMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___ch",
    path: "/ch/outfits/:slug()",
    meta: indexYRRviafY4NMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___fr-ch",
    path: "/fr-ch/ensembles/:slug()",
    meta: indexYRRviafY4NMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___de",
    path: "/de/outfits/:slug()",
    meta: indexYRRviafY4NMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___fr",
    path: "/fr/ensembles/:slug()",
    meta: indexYRRviafY4NMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___nl",
    path: "/nl/outfits/:slug()",
    meta: indexYRRviafY4NMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits-slug___uk",
    path: "/uk/outfits/:slug()",
    meta: indexYRRviafY4NMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___at",
    path: "/at/outfits",
    meta: indexWsv6dmpwmFMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___be",
    path: "/be/outfits",
    meta: indexWsv6dmpwmFMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___fr-be",
    path: "/fr-be/ensembles",
    meta: indexWsv6dmpwmFMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___ch",
    path: "/ch/outfits",
    meta: indexWsv6dmpwmFMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___fr-ch",
    path: "/fr-ch/ensembles",
    meta: indexWsv6dmpwmFMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___de",
    path: "/de/outfits",
    meta: indexWsv6dmpwmFMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___fr",
    path: "/fr/ensembles",
    meta: indexWsv6dmpwmFMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___nl",
    path: "/nl/outfits",
    meta: indexWsv6dmpwmFMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "outfits___uk",
    path: "/uk/outfits",
    meta: indexWsv6dmpwmFMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/outfits/index.vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___at",
    path: "/at/p/:slug()/:id()",
    meta: _91id_93xNZ5onoXuDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___be",
    path: "/be/p/:slug()/:id()",
    meta: _91id_93xNZ5onoXuDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___fr-be",
    path: "/fr-be/p/:slug()/:id()",
    meta: _91id_93xNZ5onoXuDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___ch",
    path: "/ch/p/:slug()/:id()",
    meta: _91id_93xNZ5onoXuDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___fr-ch",
    path: "/fr-ch/p/:slug()/:id()",
    meta: _91id_93xNZ5onoXuDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___de",
    path: "/de/p/:slug()/:id()",
    meta: _91id_93xNZ5onoXuDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___fr",
    path: "/fr/p/:slug()/:id()",
    meta: _91id_93xNZ5onoXuDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___nl",
    path: "/nl/p/:slug()/:id()",
    meta: _91id_93xNZ5onoXuDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "p-slug-id___uk",
    path: "/uk/p/:slug()/:id()",
    meta: _91id_93xNZ5onoXuDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/p/[slug]/[id].vue").then(m => m.default || m)
  },
  {
    name: "password-reset___at",
    path: "/at/password/reset",
    meta: resetnp3VX88zp2Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "password-reset___be",
    path: "/be/password/reset",
    meta: resetnp3VX88zp2Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "password-reset___fr-be",
    path: "/fr-be/password/reset",
    meta: resetnp3VX88zp2Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "password-reset___ch",
    path: "/ch/password/reset",
    meta: resetnp3VX88zp2Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "password-reset___fr-ch",
    path: "/fr-ch/password/reset",
    meta: resetnp3VX88zp2Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "password-reset___de",
    path: "/de/password/reset",
    meta: resetnp3VX88zp2Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "password-reset___fr",
    path: "/fr/password/reset",
    meta: resetnp3VX88zp2Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "password-reset___nl",
    path: "/nl/password/reset",
    meta: resetnp3VX88zp2Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "password-reset___uk",
    path: "/uk/password/reset",
    meta: resetnp3VX88zp2Meta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "search___at",
    path: "/at/search",
    meta: searchNZaPMep8ZGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___be",
    path: "/be/search",
    meta: searchNZaPMep8ZGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___fr-be",
    path: "/fr-be/search",
    meta: searchNZaPMep8ZGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___ch",
    path: "/ch/search",
    meta: searchNZaPMep8ZGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___fr-ch",
    path: "/fr-ch/search",
    meta: searchNZaPMep8ZGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___de",
    path: "/de/search",
    meta: searchNZaPMep8ZGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___fr",
    path: "/fr/search",
    meta: searchNZaPMep8ZGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___nl",
    path: "/nl/search",
    meta: searchNZaPMep8ZGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "search___uk",
    path: "/uk/search",
    meta: searchNZaPMep8ZGMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/search.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___at",
    path: "/at/service/direct-order",
    meta: direct_45order4GeNbkm3miMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___be",
    path: "/be/service/direct-order",
    meta: direct_45order4GeNbkm3miMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___fr-be",
    path: "/fr-be/service/direct-order",
    meta: direct_45order4GeNbkm3miMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___ch",
    path: "/ch/service/direct-order",
    meta: direct_45order4GeNbkm3miMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___fr-ch",
    path: "/fr-ch/service/direct-order",
    meta: direct_45order4GeNbkm3miMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___de",
    path: "/de/service/direct-order",
    meta: direct_45order4GeNbkm3miMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___fr",
    path: "/fr/service/direct-order",
    meta: direct_45order4GeNbkm3miMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___nl",
    path: "/nl/service/direct-order",
    meta: direct_45order4GeNbkm3miMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "service-direct-order___uk",
    path: "/uk/service/direct-order",
    meta: direct_45order4GeNbkm3miMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/service/direct-order.vue").then(m => m.default || m)
  },
  {
    name: "signin___at",
    path: "/at/signin",
    meta: signinXR83XyCrKPMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signin___be",
    path: "/be/signin",
    meta: signinXR83XyCrKPMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signin___fr-be",
    path: "/fr-be/signin",
    meta: signinXR83XyCrKPMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signin___ch",
    path: "/ch/signin",
    meta: signinXR83XyCrKPMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signin___fr-ch",
    path: "/fr-ch/signin",
    meta: signinXR83XyCrKPMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signin___de",
    path: "/de/signin",
    meta: signinXR83XyCrKPMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signin___fr",
    path: "/fr/signin",
    meta: signinXR83XyCrKPMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signin___nl",
    path: "/nl/signin",
    meta: signinXR83XyCrKPMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signin___uk",
    path: "/uk/signin",
    meta: signinXR83XyCrKPMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "success___at",
    path: "/at/success",
    meta: successKgd34y9kwZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "success___be",
    path: "/be/success",
    meta: successKgd34y9kwZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "success___fr-be",
    path: "/fr-be/success",
    meta: successKgd34y9kwZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "success___ch",
    path: "/ch/success",
    meta: successKgd34y9kwZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "success___fr-ch",
    path: "/fr-ch/success",
    meta: successKgd34y9kwZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "success___de",
    path: "/de/success",
    meta: successKgd34y9kwZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "success___fr",
    path: "/fr/success",
    meta: successKgd34y9kwZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "success___nl",
    path: "/nl/success",
    meta: successKgd34y9kwZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "success___uk",
    path: "/uk/success",
    meta: successKgd34y9kwZMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/success.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___at",
    path: "/at/wishlist",
    meta: wishlist1HFchInhXDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/wishlist.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___be",
    path: "/be/wishlist",
    meta: wishlist1HFchInhXDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/wishlist.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___fr-be",
    path: "/fr-be/wishlist",
    meta: wishlist1HFchInhXDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/wishlist.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___ch",
    path: "/ch/wishlist",
    meta: wishlist1HFchInhXDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/wishlist.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___fr-ch",
    path: "/fr-ch/wishlist",
    meta: wishlist1HFchInhXDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/wishlist.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___de",
    path: "/de/wishlist",
    meta: wishlist1HFchInhXDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/wishlist.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___fr",
    path: "/fr/wishlist",
    meta: wishlist1HFchInhXDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/wishlist.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___nl",
    path: "/nl/wishlist",
    meta: wishlist1HFchInhXDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/wishlist.vue").then(m => m.default || m)
  },
  {
    name: "wishlist___uk",
    path: "/uk/wishlist",
    meta: wishlist1HFchInhXDMeta || {},
    component: () => import("/home/runner/work/mad-storefront/mad-storefront/pages/wishlist.vue").then(m => m.default || m)
  }
]